//import Images
import avatar1 from "assets/images/users/avatar-1.jpg";
import avatar2 from "assets/images/users/avatar-2.jpg";
import avatar3 from "assets/images/users/avatar-3.jpg";
import avatar4 from "assets/images/users/avatar-4.jpg";
import avatar5 from "assets/images/users/avatar-5.jpg";
import avatar6 from "assets/images/users/avatar-6.jpg";
import avatar7 from "assets/images/users/avatar-7.jpg";
import avatar8 from "assets/images/users/avatar-8.jpg";
import avatar9 from "assets/images/users/avatar-9.jpg";
import avatar10 from "assets/images/users/avatar-10.jpg";

import productImg1 from "assets/images/products/new-arrival1.png";
import productImg3 from "assets/images/products/new-arrival2.png";
import productImg4 from "assets/images/products/new-arrival3.png";
import productImg5 from "assets/images/products/new-arrival4.png";
import productImg6 from "assets/images/products/rosegold.png";
import productImg7 from "assets/images/products/silver.png";
import productImg8 from "assets/images/products/weight1.png";
import productImg9 from "assets/images/products/weight2.png";

const recentOrders = [
  {
    id: 1,
    purchaseID: "#TB010338",
    customerName: "Gold Mangalsutra",
    productImage: avatar2,
    productName: "Vinod Kumar",
    amount: "₹750.00",
    orderDate: "28 Apr, 2025",
    deliveryDate: "26 May, 2025",
    vendor: "India",
    rating: 4.5,
    status: "Paid",
  },
  {
    id: 2,
    purchaseID: "#TB010337",
    customerName: "Gold Mangalsutra",
    productImage: avatar2,
    productName: "Parth",
    amount: "₹658.00",
    orderDate: "30 Mar, 2025",
    deliveryDate: "28 Jan, 2025",
    vendor: "India",
    rating: 4.8,
    status: "Paid",
  },
  {
    id: 3,
    purchaseID: "#TB010336",
    customerName: "Black Beaded Mangalsutra",
    productImage: avatar8,
    productName: "Siju",
    amount: "₹741.98",
    orderDate: "02 Apr, 2025",
    deliveryDate: "29 Dec, 2025",
    vendor: "India",
    rating: 4.3,
    status: "Paid",
  },
  {
    id: 4,
    purchaseID: "#TB010335",
    customerName: "Gold Necklace Set",
    productImage: avatar9,
    productName: "Vinod Kumar",
    amount: "₹264.37",
    orderDate: "01 Apr, 2025",
    deliveryDate: "13 Dec, 2025",
    vendor: "India",
    rating: 3.9,
    status: "Unpaid",
  },
  {
    id: 5,
    purchaseID: "#TB010334",
    customerName: "Black Beaded Mangalsutra",
    productImage: avatar10,
    productName: "Parth",
    amount: "₹349.99",
    orderDate: "31 Mar, 2025",
    deliveryDate: "03 Dec, 2025",
    vendor: "India",
    rating: 4.7,
    status: "Pending",
  },
  {
    id: 6,
    purchaseID: "#TB010333",
    customerName: "Rosegold Necklace",
    productImage: avatar3,
    productName: "Vinod Kumar",
    amount: "₹80.00",
    orderDate: "30 Mar, 2025",
    deliveryDate: "12 Apr, 2025",
    vendor: "India",
    rating: 4.4,
    status: "Paid",
  },
  {
    id: 7,
    purchaseID: "#TB010332",
    customerName: "Gold Earrings",
    productImage: avatar4,
    productName: "Parth",
    amount: "₹345.00",
    orderDate: "29 Mar, 2025",
    deliveryDate: "11 Apr, 2025",
    vendor: "India",
    rating: 4.4,
    status: "Unpaid",
  },
  {
    id: 8,
    purchaseID: "#TB010331",
    customerName: "Gold Mangalsutra",
    productImage: avatar2,
    productName: "Siju",
    amount: "₹658.00",
    orderDate: "28 Mar, 2025",
    deliveryDate: "09 Apr, 2025",
    vendor: "India",
    rating: 4.7,
    status: "Paid",
  },
];

const stockReport = [
  {
    productID: "#00541",
    productImage: productImg1,
    productName: "Gold Mangalsutra",
    updatedDate: "16 Mar, 2025",
    amount: "₹658.00",
    stockStatus: "In Stock",
    quantity: "15 PCS",
  },
  {
    productID: "#07484",
    productImage: productImg5,
    productName: "Gold Earrings",
    updatedDate: "05 Apr, 2025",
    amount: "₹145.00",
    stockStatus: "Low Stock",
    quantity: "05 PCS",
  },
  {
    productID: "#01641",
    productImage: productImg6,
    productName: "Gold Beaded Mangalsutra",
    updatedDate: "28 Apr, 2025",
    amount: "₹215.00",
    stockStatus: "Out of Stock",
    quantity: "0 PCS",
  },
  {
    productID: "#00065",
    productImage: productImg7,
    productName: "Gold Earrings",
    updatedDate: "02 Mar, 2025",
    amount: "₹79.99",
    stockStatus: "In Stock",
    quantity: "37 PCS",
  },
  {
    productID: "#00156",
    productImage: productImg8,
    productName: "Rosegold Necklace",
    updatedDate: "11 Mar, 2025",
    amount: "₹264.99",
    stockStatus: "In Stock",
    quantity: "23 PCS",
  },
  {
    productID: "#09102",
    productImage: productImg9,
    productName: "Gold ring",
    updatedDate: "19 Apr, 2025",
    amount: "₹264.99",
    stockStatus: "Low Stock",
    quantity: "23 PCS",
  },
];

const productDelivery = [
  {
    id: 1,
    productImage: productImg8,
    productName: "Gold Chain",
    productBy: "Vinod Kumar",
    productStatus: "Shipping",
    badgeColor: "warning",
  },
  {
    id: 2,
    productImage: productImg4,
    productName: "Gold Beaded Mangalsut...",
    productBy: "Parth",
    productStatus: "Delivered",
    badgeColor: "success",
  },
  {
    id: 3,
    productImage: productImg3,
    productName: "Gold Mangalsutra Set",
    productBy: "Siju",
    productStatus: "Out of Delivery",
    badgeColor: "danger",
  },
  {
    id: 4,
    productImage: productImg6,
    productName: "Rosegold Necklace",
    productBy: "Vinod Kumar",
    productStatus: "Delivered",
    badgeColor: "success",
  },
  {
    id: 5,
    productImage: productImg9,
    productName: "Gold Chain",
    productBy: "Parth",
    productStatus: "Shipping",
    badgeColor: "warning",
  },
];

const newcustomers = [
  {
    id: 1,
    productImage: avatar2,
    productName: "Vinod Kumar",
    date: "02 Jan, 2025",
  },
  {
    id: 2,
    productImage: avatar1,
    productName: "Mangesh",
    date: "24 Apr, 2025",
  },
  {
    id: 3,
    productImage: avatar3,
    productName: "Parth",
    date: "17 Apr, 2025",
  },
  {
    id: 4,
    productImage: avatar5,
    productName: "Siju",
    date: "18 Dec, 2021",
  },
  {
    id: 5,
    productImage: avatar6,
    productName: "Manish",
    date: "04 Mar, 2025",
  },
  {
    id: 6,
    productImage: avatar8,
    productName: "Mohit",
    date: "02 Jan, 2025",
  },
];

const allRevenueChartData = [
  {
    name: "Orders",
    type: "line",
    data: [180, 274, 346, 290, 370, 420, 490, 542, 510, 580, 636, 745],
  },
  {
    name: "Refunds",
    type: "area",
    data: [100, 154, 302, 411, 300, 284, 273, 232, 187, 174, 152, 122],
  },
  {
    name: "Earnings",
    type: "line",
    data: [260, 360, 320, 345, 436, 527, 641, 715, 832, 794, 865, 933],
  },
];

const monthRevenueChartData = [
  {
    name: "Orders",
    type: "line",
    data: [170, 254, 326, 260, 350, 400, 470, 522, 500, 570, 606, 725],
  },
  {
    name: "Refunds",
    type: "area",
    data: [90, 124, 152, 371, 290, 244, 253, 232, 167, 154, 132, 112],
  },
  {
    name: "Earnings",
    type: "line",
    data: [250, 350, 310, 335, 426, 517, 631, 705, 822, 774, 835, 923],
  },
];

const halfYearRevenueChartData = [
  {
    name: "Orders",
    type: "line",
    data: [160, 254, 336, 310, 390, 450, 510, 572, 540, 600, 656, 765],
  },
  {
    name: "Refunds",
    type: "area",
    data: [120, 157, 322, 491, 320, 324, 293, 262, 207, 194, 172, 132],
  },
  {
    name: "Earnings",
    type: "line",
    data: [290, 310, 380, 345, 456, 547, 631, 735, 852, 824, 895, 953],
  },
];

const yearRevenueChartData = [
  {
    name: "Orders",
    type: "line",
    data: [230, 344, 346, 310, 450, 470, 510, 642, 550, 600, 646, 765],
  },
  {
    name: "Refunds",
    type: "area",
    data: [120, 174, 342, 431, 320, 344, 293, 262, 217, 214, 172, 142],
  },
  {
    name: "Earnings",
    type: "line",
    data: [290, 390, 350, 375, 456, 547, 671, 745, 852, 814, 885, 953],
  },
];

export {
  recentOrders,
  stockReport,
  productDelivery,
  newcustomers,
  allRevenueChartData,
  monthRevenueChartData,
  halfYearRevenueChartData,
  yearRevenueChartData,
};
